import { request, requestJSON } from './request'
import { User } from './user'
import { Topic, TopicField } from './topic'

export interface Article {
  pk: number
  slug: string
  title: string
  description: string
  topics: Topic[]
  content: string
  submitted: boolean
  user: User
  published: boolean
  status?: number
}

export interface CreateArticle {
  title: string
  description: string
  topics: TopicField[]
  content: string
  submitted: boolean
}

export interface CreateArticleResp {
  object_url: string
  edit_url: string
}

export async function getArticles (): Promise<Article[]> {
  return await requestJSON('/api/articles/')
}

export async function getGuestArticles (): Promise<Article[]> {
  return await requestJSON('/api/guest-articles/')
}

export async function getArticle (articleId: number): Promise<Article> {
  return await requestJSON(`/api/articles/${articleId}/`)
}

export async function getArticleAbortable (articleId: number, controller: AbortController): Promise<Article> {
  return await requestJSON(`/api/articles/${articleId}/`, { signal: controller.signal })
}

export async function getGuestArticle (articleId: number): Promise<Article> {
  return await requestJSON(`/api/guest-articles/${articleId}/`)
}

export async function getGuestArticleAbortable (articleId: number, controller: AbortController): Promise<Article> {
  return await requestJSON(`/api/guest-articles/${articleId}/`, { signal: controller.signal })
}

export async function createArticle (body: CreateArticle): Promise<CreateArticleResp> {
  return await requestJSON('/api/guest-articles/', { method: 'POST', body })
}

export async function editArticle (articleId: number, body: CreateArticle): Promise<void> {
  await requestJSON(`/api/guest-articles/${articleId}/`, { method: 'PUT', body })
}

export async function deleteArticle (articleId: number): Promise<void> {
  await request(`/api/guest-articles/${articleId}/`, { method: 'DELETE' })
}
